export const LANGS = [
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

export const t = {
  es: {
    nav: {
      bio: "Biografía",
      profile: "Perfil",
      trajectory: "Trayectoria",
      achievements: "Logros",
      gallery: "Galería",
      contact: "Contacto",
    },
    hero: {
      badge: "Paris FC · Selección de Ecuador",
      tagline: "Velocidad, potencia y liderazgo al servicio del alto rendimiento.",
      cta: "Explorar",
      scroll: "Desliza",
      new: "Fichaje Mercato 26/27",
      newcomer: "Nueva incorporación",
    },
    bio: {
      index: "01",
      section: "Biografía",
      overlineImg: "Capitana · Selección de Ecuador",
      heading: "De Ecuador a la élite del fútbol europeo.",
      pull: "Velocidad. Potencia. Carácter. Liderazgo.",
      p1: "Manoly Baquerizo es una futbolista profesional ecuatoriana que actualmente milita en el Paris FC y es la capitana de la Selección de Ecuador Femenina. Capaz de desempeñarse como lateral o extremo izquierdo, destaca por su extraordinaria capacidad física, su intensidad competitiva y su impacto constante en las dos fases del juego.",
      p2: "Tras competir en el fútbol español defendiendo los colores del Granada CF, Deportivo Alavés y CP Cacereño, inicia un nuevo desafío en el Paris FC, uno de los proyectos más ambiciosos del fútbol francés y habitual competidor en las competiciones europeas.",
      p3: "Es una jugadora que recorre la banda de área a área durante los noventa minutos, generando superioridades ofensivas sin perder solidez defensiva. Su evolución ha estado marcada por una constante: competir siempre al máximo nivel.",
      highlights: [
        { n: "01", txt: "Capitana de la Selección de Ecuador (41 internacionalidades)" },
        { n: "02", txt: "+135 partidos oficiales en el fútbol español" },
        { n: "03", txt: "4 clubes profesionales entre España y Francia" },
      ],
    },
    profile: {
      index: "02",
      section: "Perfil de Jugadora",
      heading: "Una lateral con mentalidad de extremo.",
      subCaption: "Paris FC · Nueva etapa",
      labels: {
        position: "Posición",
        foot: "Pierna dominante",
        nationality: "Nacionalidad",
        club: "Club Actual",
        team: "Selección Nacional",
      },
      values: {
        position: "Lateral / Extremo Izquierdo",
        foot: "Izquierda",
        nationality: "Ecuador",
        club: "Paris FC",
        team: "Ecuador · Capitana",
      },
      strengthsTitle: "Principales fortalezas",
      strengths: [
        "Potencia física sobresaliente",
        "Velocidad y capacidad de aceleración",
        "Proyección ofensiva constante",
        "Llegada al área con gol y asistencias",
        "Excelente rendimiento en transiciones",
        "Dominio del uno contra uno defensivo",
        "Amplio recorrido por toda la banda",
        "Alta resistencia e intensidad competitiva",
        "Versatilidad táctica: lateral o extremo",
      ],
    },
    trajectory: {
      index: "03",
      section: "Trayectoria",
      heading: "De Guayaquil a París.",
      sub: "De sus inicios en Estados Unidos a París. Cuatro clubes profesionales.",
      current: "Club actual",
    },
    achievements: {
      index: "04",
      section: "Los números y la historia.",
      heading: "Los números y la historia.",
      statsHeading: "Números en la élite.",
      statsSub: "178 partidos oficiales entre clubes y Selección de Ecuador (fuente: Soccerway).",
      statCards: [
        { big: "178", title: "Partidos oficiales", txt: "137 con clubes profesionales en España + 41 internacionalidades con Ecuador." },
        { big: "137", title: "Partidos en España", txt: "Cacereño (80), Deportivo Alavés (30) y Granada CF (27) en Liga F y Reto Iberdrola." },
        { big: "41", title: "Internacionalidades", txt: "Partidos oficiales con la Selección de Ecuador Femenina como capitana." },
        { big: "29", title: "Goles", txt: "Anotados en el fútbol profesional español: Cacereño 18 · Alavés 6 · Granada 5." },
      ],
      teamsTitle: "Partidos por equipo",
      teamsCols: ["Equipo", "Partidos"],
      teamsRows: [
        { team: "CP Cacereño Femenino", m: "80" },
        { team: "Deportivo Alavés Gloriosas", m: "30" },
        { team: "Granada CF Femenino", m: "27" },
        { team: "Selección de Ecuador Femenina", m: "41" },
        { team: "Total oficial", m: "178", total: true },
      ],
      cacerenoTitle: "Etapa CP Cacereño (2020-2024) — Detalle por temporada",
      cacerenoCols: ["Temporada", "Partidos", "Minutos", "Goles", "Asistencias"],
      cacerenoRows: [
        { s: "2020/21", m: "—", min: "—", g: "2", a: "—" },
        { s: "2021/22", m: "27", min: "2.180", g: "6", a: "—" },
        { s: "2022/23", m: "29", min: "1.836", g: "4", a: "1" },
        { s: "2023/24", m: "24", min: "1.831", g: "6", a: "—" },
        { s: "Total", m: "80", min: "5.847", g: "18", a: "1", total: true },
      ],
      cards: [
        { big: "C", title: "Capitanía", txt: "Capitana de la Selección de Ecuador Femenina en la nueva era del combinado nacional." },
        { big: "4", title: "4 clubes pro", txt: "Cacereño, Alavés, Granada y Paris FC. Trayectoria entre España y Francia." },
        { big: "★", title: "Première Ligue", txt: "Debuta en el Paris FC con contrato hasta 2028. Marcó en su debut en liga el 06/09/26 (Paris FC 2-0 Nantes, de cabeza)." },
        { big: "EC", title: "Ecuador", txt: "Referente del fútbol femenino ecuatoriano y voz de una nueva generación." },
      ],
      panelTitle: "Llevando a Ecuador al mundo.",
      panelBullets: [
        "Capitana y líder natural de la Selección de Ecuador",
        "Voz visible del fútbol femenino ecuatoriano",
        "Inspiración para una nueva generación de futbolistas en Sudamérica",
      ],
      panelCaption: "Selección de Ecuador",
    },
    video: {
      index: "05",
      section: "Video",
      heading: "Manoly en movimiento.",
      sub: "Highlights y jugadas.",
      caption: "Highlight Reel · Vimeo",
      watch: "Ver en Vimeo",
    },
    gallery: {
      index: "06",
      section: "Galería",
      heading: "Imágenes de una carrera.",
      filters: {
        all: "Todas",
        paris: "Paris FC",
        seleccion: "Selección",
        granada: "Granada",
      },
    },
    contact: {
      index: "07",
      section: "Contacto",
      heading: "Hablemos.",
      subheading: "Representación y contacto profesional.",
      agencyLabel: "Agencia de Representación",
      agency: "Solo Cracks",
      repLabel: "Representante",
      rep: "Edgar Merino Vidangossy",
      phoneLabel: "Teléfono",
      phone: "+34 665 497 561",
      emailLabel: "Email",
      email: "merinovidangossy@gmail.com",
      igLabel: "Instagram",
      ig: "@edgarmerino19",
      igManolyLabel: "IG de Manoly",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      official: "Sitio oficial de presentación.",
    },
  },
  fr: {
    nav: {
      bio: "Biographie",
      profile: "Profil",
      trajectory: "Parcours",
      achievements: "Palmarès",
      gallery: "Galerie",
      contact: "Contact",
    },
    hero: {
      badge: "Paris FC · Sélection d'Équateur",
      tagline: "Vitesse, puissance et leadership au service du haut niveau.",
      cta: "Explorer",
      scroll: "Défiler",
      new: "Recrue Mercato 26/27",
      newcomer: "Nouvelle recrue",
    },
    bio: {
      index: "01",
      section: "Biographie",
      overlineImg: "Capitaine · Sélection d'Équateur",
      heading: "De l'Équateur à l'élite du football européen.",
      pull: "Vitesse. Puissance. Caractère. Leadership.",
      p1: "Manoly Baquerizo est une footballeuse professionnelle équatorienne qui évolue actuellement au Paris FC et occupe le brassard de capitaine de la Sélection d'Équateur féminine. Capable de jouer arrière ou ailier gauche, elle se distingue par une capacité physique remarquable, une intensité compétitive et un impact constant dans les deux phases du jeu.",
      p2: "Après avoir défendu les couleurs du Granada CF, du Deportivo Alavés et du CP Cacereño en Espagne, elle entame un nouveau défi au Paris FC, l'un des projets les plus ambitieux du football français, habitué des compétitions européennes.",
      p3: "Une joueuse qui parcourt son couloir de bout en bout pendant quatre-vingt-dix minutes, créant des supériorités offensives sans jamais céder sur la solidité défensive. Son évolution repose sur une constante : toujours concourir au plus haut niveau.",
      highlights: [
        { n: "01", txt: "Capitaine de la Sélection d'Équateur (41 sélections)" },
        { n: "02", txt: "+135 matchs officiels dans le football espagnol" },
        { n: "03", txt: "4 clubs professionnels entre l'Espagne et la France" },
      ],
    },
    profile: {
      index: "02",
      section: "Profil de Joueuse",
      heading: "Une latérale à mentalité d'ailière.",
      subCaption: "Paris FC · Nouveau chapitre",
      labels: {
        position: "Poste",
        foot: "Pied fort",
        nationality: "Nationalité",
        club: "Club actuel",
        team: "Sélection Nationale",
      },
      values: {
        position: "Arrière / Ailier Gauche",
        foot: "Gauche",
        nationality: "Équateur",
        club: "Paris FC",
        team: "Équateur · Capitaine",
      },
      strengthsTitle: "Points forts",
      strengths: [
        "Puissance physique remarquable",
        "Vitesse et capacité d'accélération",
        "Projection offensive constante",
        "Arrivées dans la surface : buts et passes",
        "Excellente dans les transitions",
        "Maîtrise du un-contre-un défensif",
        "Grande couverture du couloir",
        "Endurance et intensité compétitive",
        "Polyvalence tactique : latérale ou ailière",
      ],
    },
    trajectory: {
      index: "03",
      section: "Parcours",
      heading: "De Guayaquil à Paris.",
      sub: "De ses débuts aux États-Unis à Paris. Quatre clubs professionnels.",
      current: "Club actuel",
    },
    achievements: {
      index: "04",
      section: "Les chiffres et l'histoire.",
      heading: "Les chiffres et l'histoire.",
      statsHeading: "Chiffres au haut niveau.",
      statsSub: "178 matchs officiels entre clubs et Sélection d'Équateur (source : Soccerway).",
      statCards: [
        { big: "178", title: "Matchs officiels", txt: "137 en clubs professionnels en Espagne + 41 sélections avec l'Équateur." },
        { big: "137", title: "Matchs en Espagne", txt: "Cacereño (80), Deportivo Alavés (30) et Granada CF (27) en Liga F et Reto Iberdrola." },
        { big: "41", title: "Sélections", txt: "Matchs officiels avec la Sélection d'Équateur féminine en tant que capitaine." },
        { big: "29", title: "Buts", txt: "Marqués dans le football professionnel espagnol : Cacereño 18 · Alavés 6 · Granada 5." },
      ],
      teamsTitle: "Matchs par équipe",
      teamsCols: ["Équipe", "Matchs"],
      teamsRows: [
        { team: "CP Cacereño Femenino", m: "80" },
        { team: "Deportivo Alavés Gloriosas", m: "30" },
        { team: "Granada CF Femenino", m: "27" },
        { team: "Sélection d'Équateur féminine", m: "41" },
        { team: "Total officiel", m: "178", total: true },
      ],
      cacerenoTitle: "Étape CP Cacereño (2020-2024) — Détail par saison",
      cacerenoCols: ["Saison", "Matchs", "Minutes", "Buts", "Passes déc."],
      cacerenoRows: [
        { s: "2020/21", m: "—", min: "—", g: "2", a: "—" },
        { s: "2021/22", m: "27", min: "2.180", g: "6", a: "—" },
        { s: "2022/23", m: "29", min: "1.836", g: "4", a: "1" },
        { s: "2023/24", m: "24", min: "1.831", g: "6", a: "—" },
        { s: "Total", m: "80", min: "5.847", g: "18", a: "1", total: true },
      ],
      cards: [
        { big: "C", title: "Capitanat", txt: "Capitaine de la Sélection d'Équateur féminine dans la nouvelle ère du football national." },
        { big: "4", title: "4 clubs pro", txt: "Cacereño, Alavés, Granada et Paris FC. Carrière entre l'Espagne et la France." },
        { big: "★", title: "Première Ligue", txt: "Débuts au Paris FC avec un contrat jusqu'en 2028. A marqué pour sa première en championnat le 06/09/26 (Paris FC 2-0 Nantes, de la tête)." },
        { big: "EC", title: "Équateur", txt: "Référence du football féminin équatorien et voix d'une nouvelle génération." },
      ],
      panelTitle: "Porter l'Équateur au monde.",
      panelBullets: [
        "Capitaine et leader naturel de la Sélection d'Équateur",
        "Voix visible du football féminin équatorien",
        "Inspiration pour une nouvelle génération de footballeuses en Amérique du Sud",
      ],
      panelCaption: "Sélection d'Équateur",
    },
    video: {
      index: "05",
      section: "Vidéo",
      heading: "Manoly en mouvement.",
      sub: "Highlights et actions.",
      caption: "Highlight Reel · Vimeo",
      watch: "Voir sur Vimeo",
    },
    gallery: {
      index: "06",
      section: "Galerie",
      heading: "Images d'une carrière.",
      filters: {
        all: "Toutes",
        paris: "Paris FC",
        seleccion: "Sélection",
        granada: "Granada",
      },
    },
    contact: {
      index: "07",
      section: "Contact",
      heading: "Parlons.",
      subheading: "Représentation et contact professionnel.",
      agencyLabel: "Agence de Représentation",
      agency: "Solo Cracks",
      repLabel: "Représentant",
      rep: "Edgar Merino Vidangossy",
      phoneLabel: "Téléphone",
      phone: "+34 665 497 561",
      emailLabel: "Email",
      email: "merinovidangossy@gmail.com",
      igLabel: "Instagram",
      ig: "@edgarmerino19",
      igManolyLabel: "IG de Manoly",
    },
    footer: {
      rights: "Tous droits réservés.",
      official: "Site officiel de présentation.",
    },
  },
  en: {
    nav: {
      bio: "Biography",
      profile: "Profile",
      trajectory: "Career",
      achievements: "Achievements",
      gallery: "Gallery",
      contact: "Contact",
    },
    hero: {
      badge: "Paris FC · Ecuador National Team",
      tagline: "Speed, power and leadership at the service of high performance.",
      cta: "Explore",
      scroll: "Scroll",
      new: "Mercato 26/27 Signing",
      newcomer: "New signing",
    },
    bio: {
      index: "01",
      section: "Biography",
      overlineImg: "Captain · Ecuador National Team",
      heading: "From Ecuador to the elite of European football.",
      pull: "Speed. Power. Character. Leadership.",
      p1: "Manoly Baquerizo is a professional Ecuadorian footballer currently playing for Paris FC and captain of the Ecuador Women's National Team. Comfortable as either a full-back or a left winger, she stands out for her extraordinary physical capacity, competitive intensity and constant impact in both phases of the game.",
      p2: "After competing in Spanish football with Granada CF, Deportivo Alavés and CP Cacereño, she now begins a new challenge at Paris FC, one of the most ambitious projects in French football and a regular contender in European competitions.",
      p3: "A player who runs the flank from box to box for ninety minutes, creating offensive overloads without ever losing her defensive solidity. Her evolution has followed one constant: always competing at the highest level.",
      highlights: [
        { n: "01", txt: "Captain of the Ecuador National Team (41 caps)" },
        { n: "02", txt: "+135 official matches in Spanish football" },
        { n: "03", txt: "4 professional clubs across Spain and France" },
      ],
    },
    profile: {
      index: "02",
      section: "Player Profile",
      heading: "A full-back with a winger's mindset.",
      subCaption: "Paris FC · New chapter",
      labels: {
        position: "Position",
        foot: "Dominant foot",
        nationality: "Nationality",
        club: "Current Club",
        team: "National Team",
      },
      values: {
        position: "Left-Back / Left Winger",
        foot: "Left",
        nationality: "Ecuador",
        club: "Paris FC",
        team: "Ecuador · Captain",
      },
      strengthsTitle: "Main strengths",
      strengths: [
        "Outstanding physical power",
        "Speed and acceleration",
        "Constant offensive projection",
        "Arrival in the box: goals and assists",
        "Excellent in transitions",
        "Command of defensive one-on-ones",
        "Full coverage of the entire flank",
        "High endurance and competitive intensity",
        "Tactical versatility: full-back or winger",
      ],
    },
    trajectory: {
      index: "03",
      section: "Career",
      heading: "From Guayaquil to Paris.",
      sub: "From her beginnings in the United States to Paris. Four professional clubs.",
      current: "Current club",
    },
    achievements: {
      index: "04",
      section: "The numbers and the story.",
      heading: "The numbers and the story.",
      statsHeading: "Numbers at the top level.",
      statsSub: "178 official matches across clubs and the Ecuador National Team (source: Soccerway).",
      statCards: [
        { big: "178", title: "Official matches", txt: "137 with professional clubs in Spain + 41 caps with the Ecuador National Team." },
        { big: "137", title: "Matches in Spain", txt: "Cacereño (80), Deportivo Alavés (30) and Granada CF (27) in Liga F and Reto Iberdrola." },
        { big: "41", title: "Caps", txt: "Official appearances with the Ecuador Women's National Team as captain." },
        { big: "29", title: "Goals", txt: "Scored in Spanish professional football: Cacereño 18 · Alavés 6 · Granada 5." },
      ],
      teamsTitle: "Matches by team",
      teamsCols: ["Team", "Matches"],
      teamsRows: [
        { team: "CP Cacereño Femenino", m: "80" },
        { team: "Deportivo Alavés Gloriosas", m: "30" },
        { team: "Granada CF Femenino", m: "27" },
        { team: "Ecuador Women's National Team", m: "41" },
        { team: "Official total", m: "178", total: true },
      ],
      cacerenoTitle: "CP Cacereño era (2020-2024) — Season by season",
      cacerenoCols: ["Season", "Matches", "Minutes", "Goals", "Assists"],
      cacerenoRows: [
        { s: "2020/21", m: "—", min: "—", g: "2", a: "—" },
        { s: "2021/22", m: "27", min: "2,180", g: "6", a: "—" },
        { s: "2022/23", m: "29", min: "1,836", g: "4", a: "1" },
        { s: "2023/24", m: "24", min: "1,831", g: "6", a: "—" },
        { s: "Total", m: "80", min: "5,847", g: "18", a: "1", total: true },
      ],
      cards: [
        { big: "C", title: "Captaincy", txt: "Captain of the Ecuador Women's National Team in the new era of the national side." },
        { big: "4", title: "4 pro clubs", txt: "Cacereño, Alavés, Granada and Paris FC. A career across Spain and France." },
        { big: "★", title: "Première Ligue", txt: "Debuts for Paris FC under contract through 2028. Scored on her league debut on 06/09/26 (Paris FC 2-0 Nantes, header)." },
        { big: "EC", title: "Ecuador", txt: "A reference in Ecuadorian women's football and the voice of a new generation." },
      ],
      panelTitle: "Bringing Ecuador to the world.",
      panelBullets: [
        "Captain and natural leader of the Ecuador National Team",
        "A leading voice of Ecuadorian women's football",
        "Inspiration for a new generation of South American players",
      ],
      panelCaption: "Ecuador National Team",
    },
    video: {
      index: "05",
      section: "Video",
      heading: "Manoly in motion.",
      sub: "Highlights and plays.",
      caption: "Highlight Reel · Vimeo",
      watch: "Watch on Vimeo",
    },
    gallery: {
      index: "06",
      section: "Gallery",
      heading: "Images of a career.",
      filters: {
        all: "All",
        paris: "Paris FC",
        seleccion: "National Team",
        granada: "Granada",
      },
    },
    contact: {
      index: "07",
      section: "Contact",
      heading: "Let's talk.",
      subheading: "Professional representation and contact.",
      agencyLabel: "Representation Agency",
      agency: "Solo Cracks",
      repLabel: "Agent",
      rep: "Edgar Merino Vidangossy",
      phoneLabel: "Phone",
      phone: "+34 665 497 561",
      emailLabel: "Email",
      email: "merinovidangossy@gmail.com",
      igLabel: "Instagram",
      ig: "@edgarmerino19",
      igManolyLabel: "Manoly's IG",
    },
    footer: {
      rights: "All rights reserved.",
      official: "Official presentation site.",
    },
  },
};
